import { render, staticRenderFns } from "./CamadasAccordion.vue?vue&type=template&id=7f5d06d4&scoped=true&lang=pug"
import script from "./CamadasAccordion.vue?vue&type=script&lang=js"
export * from "./CamadasAccordion.vue?vue&type=script&lang=js"
import style0 from "./CamadasAccordion.vue?vue&type=style&index=0&id=7f5d06d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d06d4",
  null
  
)

export default component.exports